import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CATEGORIES } from "@/lib/constants";
import { BrandedImage } from "@/components/site/BrandedImage";
import { Search, ArrowRight } from "lucide-react";

export default function Articole() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const category = params.get("category") || "toate";

  useEffect(() => {
    api.get("/articles", { params: { category, q, limit: 60 } }).then(r => setItems(r.data || [])).catch(() => {});
  }, [category, q]);

  const setCategory = (c) => {
    const p = new URLSearchParams(params);
    if (c === "toate") p.delete("category"); else p.set("category", c);
    setParams(p);
  };

  return (
    <div data-testid="page-articole" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-10 md:mb-14">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Bibliotecă</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Articole</h1>
        <p className="mt-4 text-[#A0AABF] max-w-2xl text-lg">Înțelege fenomenul. Documentează situația. Acționează informat.</p>
      </header>

      <div className="flex flex-col md:flex-row gap-4 mb-10">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6C7A9C]" />
          <input
            data-testid="articles-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Caută articole..."
            className="w-full pl-10 pr-4 py-3 bg-[#131B2E] border border-white/10 rounded-sm text-[#F8F8F4] placeholder-white/30 focus:border-[#D4A63D] outline-none"
          />
        </div>
      </div>

      <div className="flex gap-2 flex-wrap mb-10">
        <button
          data-testid="filter-all"
          onClick={() => setCategory("toate")}
          className={`px-4 py-2 rounded-sm text-sm transition-all ${category === "toate" ? "bg-[#D4A63D] text-[#0A1020]" : "bg-white/5 text-[#A0AABF] hover:bg-white/10"}`}
        >Toate</button>
        {CATEGORIES.map(c => (
          <button
            key={c.value}
            data-testid={`filter-${c.value}`}
            onClick={() => setCategory(c.value)}
            className={`px-4 py-2 rounded-sm text-sm transition-all ${category === c.value ? "bg-[#D4A63D] text-[#0A1020]" : "bg-white/5 text-[#A0AABF] hover:bg-white/10"}`}
          >{c.label}</button>
        ))}
      </div>

      {items.length === 0 ? (
        <p className="text-[#A0AABF] italic">Nu există rezultate.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(a => (
            <Link key={a.article_id} to={`/articole/${a.slug}`} data-testid={`article-${a.slug}`} className="cinematic-card rounded-lg overflow-hidden group block">
              <div className="relative aspect-[16/10] overflow-hidden">
                <BrandedImage
                  src={a.hero_image}
                  alt={a.title}
                  className="absolute inset-0 w-full h-full group-hover:scale-105 transition-transform duration-700"
                  watermarkPosition="br"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1020] to-transparent pointer-events-none z-[5]" />
                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.25em] text-[#D4A63D] bg-[#0A1020]/85 px-2 py-1 border border-[#D4A63D]/30 z-10">{a.category}</span>
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg md:text-xl text-[#F8F8F4] group-hover:text-[#D4A63D] transition-colors line-clamp-2 leading-snug">{a.title}</h3>
                <p className="text-sm text-[#A0AABF] mt-3 line-clamp-2 leading-relaxed">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-[#6C7A9C]">
                  <span>{a.reading_time} min</span>
                  <span className="flex items-center gap-1">Citește <ArrowRight className="w-3 h-3" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
